import { useCallback, useRef } from 'react';

interface PendingFocusTarget {
  target: 'collapse' | 'expand';
}

/** @internal */
export function useButtonFocusHandover() {
  const pendingTarget = useRef<PendingFocusTarget | null>(null);

  const setTarget = useCallback((target: 'collapse' | 'expand') => {
    pendingTarget.current = { target };
  }, []);

  const collapseButtonRef = useCallback((node: HTMLButtonElement | null) => {
    if (node && pendingTarget.current?.target === 'collapse') {
      node.focus();
      pendingTarget.current = null;
    }
  }, []);

  const expandButtonRef = useCallback((node: HTMLButtonElement | null) => {
    if (node && pendingTarget.current?.target === 'expand') {
      node.focus();
      pendingTarget.current = null;
    }
  }, []);

  return {
    setTarget,
    collapseButtonRef,
    expandButtonRef,
  };
}
